export default "__VITE_ASSET__a18185fa__"